import PropTypes from "prop-types";
import { CustomContainer, Form, Col } from "../../DependencyHelper";
import { createMarkup } from "../../../../utils/helperServices";
import formStyles from "../CheckoutForms.module.scss";
import styles from "./TermsCheckbox.module.scss";

const TermsCheckbox = ({
  formName,
  label,
  fieldName,
  fieldValues,
  fieldErrors,
  fieldErrorsMessage,
  onChangeHandler,
  onBlurHandler,
  className,
}) => {
  const errorClass = fieldErrors[fieldName] ? styles["invalid"] : "";

  const handleChange = (event) => {
    onChangeHandler(event, null, formName);
  };

  const handleBlur = (event) => {
    onBlurHandler(event, null, formName);
  };

  return (
    <>
      <CustomContainer
        className={`${errorClass} ${styles["main-container"]} ${formStyles["main-container"]} ${className}`}
        id={`${fieldName}-checkout-condition`}
      >
        <Form.Row className={`${styles["main-row"]} ${formStyles["main-row"]}`}>
          <Form.Group
            as={Col}
            sm="12"
            md="12"
            className={formStyles["form-group"]}
          >
            <Form.Check
              custom
              className={`${styles["form-checkbox-label"]} ${formStyles["form-checkbox-label"]}`}
              id={`validationFormtc101-${fieldName}`}
            >
              <Form.Check.Input
                name={fieldName}
                type="checkbox"
                checked={fieldValues[fieldName]}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              <Form.Check.Label id={`validationFormtc101-${fieldName}-label`}>
                <span dangerouslySetInnerHTML={createMarkup(label)}></span>
              </Form.Check.Label>
            </Form.Check>
          </Form.Group>
        </Form.Row>
      </CustomContainer>

      {fieldErrors[fieldName] && (
        <CustomContainer className={styles["invalid-feedback"]}>
          {fieldErrorsMessage[fieldName]}
        </CustomContainer>
      )}
    </>
  );
};

TermsCheckbox.propTypes = {
  formName: PropTypes.string,
  label: PropTypes.any,
  fieldName: PropTypes.string,
  fieldValues: PropTypes.object,
  fieldErrors: PropTypes.object,
  fieldErrorsMessage: PropTypes.object,
  onChangeHandler: PropTypes.func,
  onBlurHandler: PropTypes.func,
};

TermsCheckbox.defaultProps = {
  formName: "termsCheckbox",
  fieldName: "terms",
  fieldValues: {},
  fieldErrors: {},
  fieldErrorsMessage: {},
};

export default TermsCheckbox;
